/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types'
], function (resources, ReactDOM, React, Toolkit, PropTypes) {
	'use strict';

	const { Dialog } = Toolkit;

	class EditableComponent extends React.Component {

		constructor(props = {}) {
			super(props);
			this.dialogProps = {
				clickaway: false,
				size: 'large',
				className: 'dashboardEditableDialog',
				startingFocusIndex: 0 // the textarea
			};
		}

		render() {
			return(
				<Dialog
					{...this.dialogProps}
					onClose={this._onClose.bind(this)}
				>
					<Dialog.Header title={this.props.title}>
						{this.props.title}
					</Dialog.Header>
					<Dialog.Body>
						<textarea>{this.props.textContent}</textarea>
					</Dialog.Body>
					<Dialog.Footer>
						<Dialog.Button
							primary={!this.props.onUpdate}
							id='copy'
							label={resources.get('copyButton')}
							title={resources.get('copyButton')}
							onClick={this._onCopy.bind(this)}
						/>
						{this.props.onUpdate && <Dialog.Button
							primary
							id='update'
							label={resources.get('dlg_update')}
							title={resources.get('dlg_update')}
							onClick={this._onUpdate.bind(this)}
						/>}
						<Dialog.Button
							label={resources.get('close')}
							title={resources.get('close')}
							id='close'
							onClick={this._onClose.bind(this)}
						/>
					</Dialog.Footer>
				</Dialog>
			);

		}

		_onCopy(evt) {
			if (evt) {
				evt.stopPropagation();
			}
			document.execCommand('copy');
		}

		_onUpdate(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			if (this.props.onUpdate){
				this.props.onUpdate();
			}
		}

		_onClose(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			if (this.props.onClose){
				this.props.onClose();
			}
		}
	}

	EditableComponent.propTypes = {
		title: PropTypes.string,
		textContent: PropTypes.string,
		onUpdate: PropTypes.func,
		onClose: PropTypes.func
	};
	return EditableComponent;
});
